import React from "react";
import styled, { css } from "styled-components";

const Svg = styled.svg(({ theme }) => css`
  path {
    fill: ${theme.palette.modal.accent};
  }
`);

export const Alert = ({className}) => (
  <Svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path d="M501.35 369.069L320.565 66.266c-13.667-23.008-37.805-36.749-64.567-36.749-26.762 0-50.9 13.741-64.567 36.749L10.662 369.069c-13.96 23.492-14.224 51.706-.719 75.462 13.536 23.771 37.922 37.951 65.27 37.951h361.57c27.348 0 51.736-14.18 65.27-37.951 13.507-23.755 13.243-51.97-.703-75.462zM255.999 122.094c16.587 0 30.032 13.445 30.032 30.032v120.13c0 16.585-13.445 30.032-30.032 30.032s-30.032-13.448-30.032-30.032v-120.13c-.001-16.587 13.445-30.032 30.032-30.032zm0 300.323c-24.841 0-45.049-20.208-45.049-45.049s20.208-45.049 45.049-45.049 45.049 20.208 45.049 45.049c-.001 24.842-20.208 45.049-45.049 45.049z" fill="#FFF"/>
  </Svg>
);

